import {DownOutlined} from '@ant-design/icons';
import {Button, Dropdown} from 'antd';
import PropTypes from 'prop-types';
import {BiSort} from 'react-icons/bi';

const SortDropdown = ({sortType, setSortType}) => {
  const items = [
    {
      key: 'new',
      label: 'New Arrivals',
    },
    {
      key: 'low-high',
      label: 'Price: Low → High',
    },
    {
      key: 'high-low',
      label: 'Price: High → Low',
    },
  ];

  const selectedLabel =
    items.find(item => item.key === sortType)?.label || 'New Arrivals';

  return (
    <div className={''}>
      <Dropdown
        menu={{
          items,
          onClick: ({key}) => setSortType(key),
        }}
        trigger={['click']}r
        className={'pr-4'}
      >
        <Button
          type={'default'}
          className={'md:w-52 w-60 flex items-center justify-between font-semibold h-12 lg:h-10 text-base'}
        >
          <span className={'flex items-center gap-2'}>
            <BiSort size={18} />
            {selectedLabel}
          </span>
          <DownOutlined className={'text-xs'} />
        </Button>
      </Dropdown>
    </div>
  );
};

SortDropdown.propTypes = {
  sortType: PropTypes.string,
  setSortType: PropTypes.func,
};

export default SortDropdown;
